'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

require('../styles/DeletePrompt.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeletePrompt = function (_BcReactComponent) {
  _inherits(DeletePrompt, _BcReactComponent);

  function DeletePrompt() {
    _classCallCheck(this, DeletePrompt);

    return _possibleConstructorReturn(this, (DeletePrompt.__proto__ || Object.getPrototypeOf(DeletePrompt)).apply(this, arguments));
  }

  _createClass(DeletePrompt, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          message = _props.message,
          handleCancel = _props.handleCancel,
          handleDelete = _props.handleDelete;


      return _react2.default.createElement(
        'div',
        { className: 'cp-delete-prompt' },
        _react2.default.createElement(
          'div',
          { className: 'contents' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h3',
              {
                className: 'message',
                'data-test-id': 'prompt-message',
                tabIndex: '-1' },
              message
            )
          ),
          _react2.default.createElement(
            _baseButtons.PrimaryButton,
            {
              handleClick: handleDelete,
              'data-test-id': 'confirm-delete-button',
              className: 'confirm-delete-button' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_delete_confirm' })
          ),
          _react2.default.createElement(
            _baseButtons.TextButton,
            {
              'data-test-id': 'cancel-button',
              className: 'cancel-button',
              handleClick: handleCancel },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_cancel' })
          ),
          _react2.default.createElement(
            'p',
            { className: 'delete-warning' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_delete_warning' })
          )
        )
      );
    }
  }]);

  return DeletePrompt;
}(_baseBcReactComponent2.default);

DeletePrompt.propTypes = {
  message: _react.PropTypes.string,
  handleDelete: _react.PropTypes.func.isRequired,
  handleCancel: _react.PropTypes.func.isRequired
};

exports.default = DeletePrompt;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/delete-prompt/components/DeletePrompt.component.js
// module id = 1284
// module chunks = 0